// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { get } from "@insite/client-framework/Services/ApiService";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/SignIn/Handlers/ReloadPageIfAuthenticated";

/**
 * WEST-791
 * Fix Firefox can’t establish a connection to the server at __webpack_hmr
 */
const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        props.result = await get<{ isAuthenticatedOnServer: boolean }>("/account/isauthenticated", {});
    } catch (e) {
        return false;
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
